var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"knowledgeMarket"},[_c('div',{staticStyle:{"position":"relative","z-index":"1000"}},[_c('nav-bar',{ref:"searchInfoContainer",on:{"searchInfo":_vm.searchInfo}})],1),_vm._v(" "),_c('div',[_c('knowledge-search',{ref:"knowledgeSearchContainer",on:{"searchInfo":_vm.searchInfo}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e78730c0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/knowledgeMarket.vue
// module id = null
// module chunks = 